export default __webpack_public_path__ + "ultimate-champion-mobile-20ae53293106fa0a8a33f7ec2a149167.png";